import { render, staticRenderFns } from "./chapterAdmin.vue?vue&type=template&id=a9069f00&scoped=true&"
import script from "./chapterAdmin.vue?vue&type=script&lang=js&"
export * from "./chapterAdmin.vue?vue&type=script&lang=js&"
import style0 from "./chapterAdmin.vue?vue&type=style&index=0&id=a9069f00&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9069f00",
  null
  
)

export default component.exports